import React from 'react';
import PropTypes from 'prop-types';

function Ai2({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M19.7096 5.31474L18.686 4.29111C18.596 4.20019 18.4889 4.12802 18.3708 4.07877C18.2528 4.02951 18.1262 4.00415 17.9982 4.00415C17.8703 4.00415 17.7437 4.02951 17.6256 4.07877C17.5076 4.12802 17.4005 4.20019 17.3105 4.29111L4.2912 17.3104C4.20028 17.4004 4.12811 17.5075 4.07886 17.6255C4.0296 17.7436 4.00424 17.8702 4.00424 17.9981C4.00424 18.1261 4.0296 18.2527 4.07886 18.3708C4.12811 18.4888 4.20028 18.5959 4.2912 18.6859L5.31483 19.7095C5.40425 19.8014 5.51118 19.8745 5.62931 19.9243C5.74743 19.9742 5.87436 19.9999 6.00258 19.9999C6.1308 19.9999 6.25772 19.9742 6.37585 19.9243C6.49397 19.8745 6.60091 19.8014 6.69033 19.7095L19.7096 6.69024C19.8015 6.60081 19.8746 6.49388 19.9244 6.37576C19.9743 6.25763 20 6.13071 20 6.00249C20 5.87426 19.9743 5.74734 19.9244 5.62922C19.8746 5.51109 19.8015 5.40416 19.7096 5.31474Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.5999 8.00177L15.9999 10.4019" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.40247 7.20203V10.4009" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5984 13.5997V16.7986" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.401 4.00317V5.60324" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.00188 8.80145H4.80304" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.1978 15.1992H15.999" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.2013 4.80292H9.60129" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Ai2.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Ai2;
